module.exports = __webpack_public_path__ + "img/企业统计 等级.9aa43ebb.png";